import { render, staticRenderFns } from "./SingleBanner.vue?vue&type=template&id=ed21e5da&scoped=true&"
import script from "./SingleBanner.vue?vue&type=script&lang=js&"
export * from "./SingleBanner.vue?vue&type=script&lang=js&"
import style0 from "./SingleBanner.vue?vue&type=style&index=0&id=ed21e5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21e5da",
  null
  
)

export default component.exports